import { getLevelsData } from '../../api/restApi';
import {
  setAllLevel,
  setLevel1,
  setLevel2,
  setLevel3,
} from '../reducer/levelSlice';

export const updateAllLevels = async (props) => {
  const levelsData = await getLevelsData();
  console.log('Firebase Data: ', levelsData);
  if (levelsData) {
    props(setAllLevel(levelsData));
    props(setLevel1(levelsData.level1));
    props(setLevel2(levelsData.level2));
    props(setLevel3(levelsData.level3));
  }
};
